import { addCardButtonStyles } from "@insite/content-library/Widgets/SavedPayments/SavedPaymentsAddCardButton";

addCardButtonStyles.addCardButton = {
    ...addCardButtonStyles.addCardButton,

    variant: "primary",
};
